// Keep this module intentionally small: zod-config must execute before the
// application module graph is even requested. A static import of main would
// evaluate its dependencies first, allowing a schema to trigger Zod's eval
// capability probe before `jitless` is configured.
import './zod-config';

void import('./main');
